<script setup lang="ts">
import { OrganizationData, UserProfile } from '@/views/Dashboard/components';

import { Heading } from '@/components/custom';
</script>

<template>
  <Heading
    size="h3"
    class="font-medium md:text-3xl mb-7 min-h-9 h-max"
    data-testid="dashboard-title"
    >{{ $t('organizationDashboard.dashboard') }}
  </Heading>

  <div class="flex flex-col gap-7 pr-2 lg:h-[calc(100dvh-12rem)] overflow-auto">
    <UserProfile />

    <OrganizationData />
  </div>
</template>
